import Header from "../components/ui/header"
import Footer from "../components/ui/footer"
import DownloadPage from "../download/download"
import React from "react";

export default function Download() {
  return (
    <div>
      <Header />
      <DownloadPage />
      <Footer />
    </div>
  )
}

